import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Star } from 'lucide-react';
export function PainPoints() {
  const points = ['Días sin ir al baño aunque comiste "bien" y tomaste agua', 'Panza dura a la derecha que no baja aunque hagas dieta', 'El laxante que ya no hace efecto si no subís la dosis', 'Ganas que aparecen pero el cuerpo no puede terminar de soltar', 'Fatiga, niebla mental y piel opaca que nadie conecta con el intestino', 'Años buscando soluciones que solo funcionan mientras las hacés'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-159">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-160" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-161">
        <div className="max-w-4xl mx-auto" data-id="element-162">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-163">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif]" data-id="element-164">
              ¿Cuántos años más vas a seguir así?
            </h2>

            {/* Highlight: Hartas de la fibra */}
            <div className="inline-block bg-red-900/20 border border-red-500/40 rounded-full px-5 py-2 mb-6" data-id="element-165">
              <p className="text-red-300 font-bold text-sm md:text-base uppercase tracking-wide" data-id="element-166">
                😤 Hartas de la fibra y el agua sin ver resultados
              </p>
            </div>

            <p className="text-gray-300 mb-4 text-[17px]" data-id="element-167">
              Ya probaste salvado, ciruelas y laxantes. Todo funcionó a medias o
              dejó de funcionar. El consejo de "comé fibra y tomá agua" no
              alcanzó.
            </p>

            {/* Biofilm explanation */}
            <p className="text-gray-300 text-[16px] mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-168">
              ¿La razón? El verdadero problema se llama{' '}
              <span className="text-brand-gold font-bold" data-id="element-169">Biofilm</span>: una
              costra mucosa que se pega a las paredes del colon y que ningún
              laxante puede sacar.
            </p>

            <p className="text-[20px] font-[500] text-[#22C55E]" data-id="element-170">
              No es tu culpa. No te falta voluntad, te falta un sistema.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-12" data-id="element-171">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-172">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-173" />
                <p className="text-lg text-gray-200" data-id="element-174">{point}</p>
              </motion.div>)}
          </div>

          {/* Strategic Testimonial - Emotional relief after pain list */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-brand-green/15 to-brand-green/5 border-2 border-brand-green/40 rounded-2xl p-6 md:p-8 mb-12 max-w-2xl mx-auto" data-id="element-175">
            <div className="flex items-center gap-4 mb-4" data-id="element-176">
              <div className="w-14 h-14 rounded-full bg-brand-dark border-2 border-brand-green/50 flex items-center justify-center text-brand-light font-bold text-lg shrink-0" data-id="element-177">
                MG
              </div>
              <div data-id="element-178">
                <div className="font-bold text-white text-base" data-id="element-179">María G.</div>
                <div className="text-sm text-gray-400" data-id="element-180">
                  📍 Tucumán, Argentina
                </div>
                <div className="flex gap-0.5 mt-1" data-id="element-181">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-brand-gold fill-brand-gold" data-id="element-182" />)}
                </div>
              </div>
            </div>
            <p className="text-gray-100 text-base md:text-lg italic leading-relaxed" data-id="element-183">
              "Llevaba 12 años tomando sen todas las noches. A las 3 semanas del
              sistema fui sola por primera vez.{' '}
              <span className="text-brand-light font-bold not-italic" data-id="element-184">
                Lloré en el baño.
              </span>
              "
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-185">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-186">
              ¿Y si pudieras dejar de sentirte así a partir de hoy mismo?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}